import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Fade + rise on scroll into view
export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px -10% 0px" });
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </MotionTag>
  );
};

// Masked line-by-line reveal for headings. lines: array of strings.
export const LineReveal = ({ lines, className = "", lineClassName = "", delay = 0, start = false }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-5% 0px" });
  const active = start || inView;
  return (
    <span ref={ref} className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={active ? { y: "0%" } : {}}
            transition={{ duration: 1, ease: EASE, delay: delay + i * 0.12 }}
            aria-hidden="true"
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const staggerParent = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09 } },
};

export const staggerChild = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
};

export { EASE };
